import Vue from "vue";

export const NavigationMixin = Vue.extend({
  methods: {
    navigate(path: string, event?: MouseEvent) {
      if (event?.ctrlKey || event?.metaKey) {
        const url = this.$router.resolve(path).href;
        window.open(url, '_blank');
      } else {
        this.$router.push(path).catch((err: any) => { if (err?.name !== "NavigationDuplicated") throw err; });
      }
    },
  },
});